import { differenceInCalendarDays, format } from "date-fns";

/** Resignation.approval_status → label and the badge tone it renders with.
 *  "cancelled" is the employee withdrawing a pending request. */
export const RESIGNATION_STATUS = {
  pending: { label: "Pending", tone: "warning" },
  approved: { label: "Approved", tone: "success" },
  rejected: { label: "Rejected", tone: "danger" },
  cancelled: { label: "Cancelled", tone: "neutral" },
};

export const RESIGNATION_STATUS_FILTERS = [
  { key: "", label: "All" },
  ...Object.entries(RESIGNATION_STATUS).map(([key, { label }]) => ({ key, label })),
];

export const fullName = (person) =>
  [person?.first_name, person?.last_name].filter(Boolean).join(" ") || "-";

export const formatDay = (value) => (value ? format(new Date(value), "dd MMM yyyy") : "-");

export const formatDayTime = (value) => (value ? format(new Date(value), "dd MMM yyyy, HH:mm") : "-");

const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;

/** "today", "tomorrow", "in 3 days", "5 days ago" — relative to the viewer's today. */
export const relativeDay = (value) => {
  if (!value) return "";
  const diff = differenceInCalendarDays(new Date(value), new Date());
  if (diff === 0) return "today";
  if (diff === 1) return "tomorrow";
  if (diff === -1) return "yesterday";
  return diff > 0 ? `in ${plural(diff, "day")}` : `${plural(-diff, "day")} ago`;
};

/** Days between the request and the last working day it asks for.
 *  null when either date is missing, so callers can omit the line. */
export const noticeDays = (resignation) => {
  if (!resignation?.created_at || !resignation?.last_working_day) return null;
  return differenceInCalendarDays(
    new Date(resignation.last_working_day),
    new Date(resignation.created_at)
  );
};

export const noticeLabel = (days) => {
  if (days === null) return "";
  if (days < 0) return "LWD before request date";
  if (days === 0) return "Same-day notice";
  return `${plural(days, "day")} notice`;
};

/** A pending request whose last working day is already behind us — the one
 *  row on this list someone needs to act on now. */
export const isOverdue = (resignation) =>
  resignation?.approval_status === "pending" &&
  !!resignation?.last_working_day &&
  differenceInCalendarDays(new Date(resignation.last_working_day), new Date()) < 0;
